//geo ip
//this is use to get user's ip address
export const GEOIP_REQUEST = "GEOIP_REQUEST";
export const GEOIP_RECEIVE = "GEOIP_RECEIVE";
export const GEOIP_FAILURE = "GEOIP_FAILURE";
export const GEOIP_RESET = "GEOIP_RESET";

export const DEVICE_INFO = "DEVICE_INFO";